export default "__VITE_ASSET__BptvaIoK__"